import { render, staticRenderFns } from "./RegViewProspectiveStudent.vue?vue&type=template&id=e757ac56"
import script from "./RegViewProspectiveStudent.vue?vue&type=script&lang=js"
export * from "./RegViewProspectiveStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports